var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import _ from 'lodash';
import { Formio } from 'formiojs';
var dragula;
if (typeof window !== 'undefined') {
    // Import from "dist" because it would require and "global" would not be defined in Angular apps.
    // tslint:disable-next-line
    dragula = require('dragula/dist/dragula');
}
var Components = Formio.Components;
var EditGridComponent = Formio.Components.components.editgrid;
var RowGrid = /** @class */ (function (_super) {
    __extends(RowGrid, _super);
    function RowGrid() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        _this.type = 'rowgrid';
        return _this;
    }
    RowGrid.schema = function () {
        var extend = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            extend[_i] = arguments[_i];
        }
        return EditGridComponent.schema.apply(EditGridComponent, __spreadArrays([{
                type: 'rowgrid',
                label: 'Row Grid',
                key: 'rowGrid',
            }], extend));
    };
    Object.defineProperty(RowGrid, "builderInfo", {
        get: function () {
            return {
                title: 'Row Grid',
                group: 'data',
                weight: 0,
                schema: RowGrid.schema()
            };
        },
        enumerable: false,
        configurable: true
    });
    RowGrid.prototype.loadRefs = function (element, refs) {
        _super.prototype.loadRefs.call(this, element, refs);
        if (refs['editgrid-listgroup'] === 'single') {
            var container = _.last(element.querySelectorAll('ul.editgrid-listgroup'));
            this.refs['editgrid-listgroup'] = container || this.refs['editgrid-listgroup'];
        }
    };
    RowGrid.prototype.attach = function (element) {
        var _a;
        var _this = this;
        if (this.builderMode) {
            return _super.prototype.attach.call(this, element);
        }
        this.loadRefs(element, (_a = {
                'editgrid-listgroup': 'single'
            },
            _a[this.addRowRef] = 'multiple',
            _a[this.saveRowRef] = 'multiple',
            _a[this.cancelRowRef] = 'multiple',
            _a[this.rowRef] = 'multiple',
            _a[this.editgridKey] = 'multiple',
            _a));
        this.allowReorder = true;
        if (this.allowReorder) {
            this.refs[this.editgridKey + "-row"].forEach(function (row, index) {
                row.dragInfo = { index: index };
            });
            if (dragula) {
                this.dragula = dragula([this.refs['editgrid-listgroup']], {}).on('drop', this.onReorder.bind(this));
            }
        }
        this.addRowElements.forEach(function (addButton) {
            _this.addEventListener(addButton, 'click', function () { return _this.addRow(); });
        });
        var openRowCount = 0;
        this.rowElements.forEach(function (row, rowIndex) {
            var editRow = _this.editRows[rowIndex];
            if (editRow === null || editRow === void 0 ? void 0 : editRow.isRowSelected) {
                row.classList.add('selected');
            }
            if (_this.isOpen(editRow)) {
                _this.attachComponents(row, editRow.components);
                _this.addEventListener(_this.saveRowElements[openRowCount], 'click', function () { return _this.saveRow(rowIndex, true); });
                _this.addEventListener(_this.cancelRowElements[openRowCount], 'click', function () { return _this.cancelRow(rowIndex); });
                openRowCount++;
            }
            else {
                // Attach edit and remove button events.
                [
                    {
                        className: 'removeRow',
                        event: 'click',
                        action: function () { return _this.removeRow(rowIndex, true); },
                    },
                    {
                        className: 'editRow',
                        event: 'click',
                        action: function () {
                            _this.editRow(rowIndex).then(function () {
                                var _a;
                                if (_this.component.rowDrafts) {
                                    _this.validateRow(editRow, false);
                                    var hasErrors = editRow.errors && !!editRow.errors.length;
                                    var shouldShowRowErrorsAlert = _this.component.modal && hasErrors && ((_a = _this.root) === null || _a === void 0 ? void 0 : _a.submitted);
                                    if (shouldShowRowErrorsAlert) {
                                        _this.alert.showErrors(editRow.errors, false);
                                        editRow.alerts = true;
                                    }
                                }
                            });
                        },
                    },
                    {
                        className: 'row',
                        event: 'click',
                        action: function () {
                            row.classList.toggle('selected');
                            var eventName = 'editGridSelectRow';
                            if (Array.from(row.classList).includes('selected')) {
                                editRow.isRowSelected = true;
                            }
                            else {
                                delete editRow.isRowSelected;
                                eventName = 'editGridUnSelectRow';
                            }
                            _this.emit(eventName, {
                                component: _this.component,
                                data: _this.dataValue[rowIndex]
                            });
                        },
                    }
                ].forEach(function (_a) {
                    var className = _a.className, event = _a.event, action = _a.action;
                    var elements = row.getElementsByClassName(className);
                    Array.prototype.forEach.call(elements, function (element) {
                        _this.addEventListener(element, event, action);
                    });
                });
            }
        });
        // Add open class to the element if any edit grid row is open
        if (openRowCount) {
            this.addClass(this.refs.component, "formio-component-" + this.component.type + "-row-open");
        }
        else {
            this.removeClass(this.refs.component, "formio-component-" + this.component.type + "-row-open");
        }
        var superAttach = _super.prototype.attach.call(this, element);
        this.loadRefs(element, {
            messageContainer: 'single-scope',
        });
        return superAttach;
    };
    RowGrid.prototype.onReorder = function (element, _target, _source, sibling) {
        if (!element.dragInfo || (sibling && !sibling.dragInfo)) {
            return;
        }
        var oldPosition = element.dragInfo.index;
        // should drop at next sibling position no next sibling means drop to last position
        var newPosition = sibling ? sibling.dragInfo.index : this.dataValue.length;
        var movedBelow = newPosition > oldPosition;
        var draggedRowData = this.dataValue[oldPosition];
        // insert element at new position
        this.dataValue.splice(newPosition, 0, draggedRowData);
        // remove element from old position (if was moved above, after insertion it's at +1 index)
        this.dataValue.splice(movedBelow ? oldPosition : oldPosition + 1, 1);
        // need to re-build rows to re-calculate indexes and other indexed fields for component instance (like rows for ex.)
        this.setValue(this.dataValue, { isReordered: true });
        this.rebuild();
    };
    return RowGrid;
}(EditGridComponent));
export default RowGrid;
Components.addComponent('rowgrid', RowGrid);
